/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import React, {Fragment} from "react";
import {userProfileImage} from "../../../Redux/Selectors";

export class UserNameFieldViewer extends BaseFieldViewer {
	@autobind
	_render() {
		return <Fragment>
			<div className="sb-account-icon">
				<img src={userProfileImage(this.props.Data)} alt=""/>
			</div>
			{this.props.Value}
		</Fragment>;
	}
}